// The Scoring tab's two exclusive chip groups, rendered by StatusFilterPanel
// (same column-of-chips layout as the Status tab). `value` carries the API
// token sent as filterBenchmark / filterDemand; `name` feeds the
// "merchandising.show.label.filters.<name>" chip labels.
//
// Benchmark = Google Merchant price competitiveness (equivalent = within ±3%);
// demand = search-impression tiers (high ≥ 2000, mid-high 1200–1999,
// mid-low 900–1199, low < 900 — products without any impression included).
export const SCORING_FILTER_GROUPS = [
    {
        tabTitle: "benchmark",
        tabContent: {
            items: [
                {"@type": "Benchmark", id: "benchmark-higher", name: "benchmark.higher", value: "higher"},
                {"@type": "Benchmark", id: "benchmark-lower", name: "benchmark.lower", value: "lower"},
                {"@type": "Benchmark", id: "benchmark-equivalent", name: "benchmark.equivalent", value: "equivalent"},
            ],
        },
    },
    {
        tabTitle: "demand",
        tabContent: {
            items: [
                {"@type": "Demand", id: "demand-high", name: "demand.high", value: "high"},
                {"@type": "Demand", id: "demand-mid-high", name: "demand.mid-high", value: "mid-high"},
                {"@type": "Demand", id: "demand-mid-low", name: "demand.mid-low", value: "mid-low"},
                {"@type": "Demand", id: "demand-low", name: "demand.low", value: "low"},
            ],
        },
    },
];
